import { getAdminToken } from './admin'

const API_URL = process.env.REACT_APP_API_URL

interface LoginCredentials {
  email: string
  password: string
}

export const loginUser = async (credentials: LoginCredentials) => {
  try {
    const response = await fetch(`${API_URL}/users/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials),
    })

    const data = await response.json()

    if (response.ok) {
      // Return the response data, including user info and token
      return {
        success: true,
        data: data,
      }
    } else {
      // Return a structured response indicating failure
      return {
        success: false,
        message: data.message || 'Login failed',
      }
    }
  } catch (error) {
    console.error('Error trying to login', error)
    throw new Error('An error occurred during login')
  }
}

export const getUserProfileByToken = async (token: string) => {
  try {
    const adminToken = getAdminToken()
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
    }
    if (adminToken) {
      headers['Authorization'] = `Bearer ${adminToken}`
    }

    const response = await fetch(`${API_URL}/users/get-user-profile/${token}`, {
      method: 'GET',
      headers,
    })

    if (response.ok) {
      const data = await response.json()
      // Return the response data, including user info
      return {
        success: true,
        data: data,
      }
    } else {
      // Handle error response if needed
      const errorData = await response.json()
      return {
        success: false,
        message: errorData.message || 'Failed to fetch user profile',
      }
    }
  } catch (error) {
    console.error('Error trying to fetch user profile', error)
    throw new Error('An error occurred while fetching user profile')
  }
}

export const fetchAllUsers = async () => {
  try {
    const token = getAdminToken()
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
    }
    if (token) {
      headers['Authorization'] = `Bearer ${token}`
    }

    const response = await fetch(`${API_URL}/users`, {
      method: 'GET',
      headers,
    })

    const data = await response.json()

    if (response.ok) {
      // Return the response data if the request was successful
      return {
        success: true,
        users: data.userProfiles, // Assuming the response has a 'userProfiles' key with user data
      }
    } else {
      // Handle errors if the request was unsuccessful
      return {
        success: false,
        message: data.message || 'Failed to fetch users',
      }
    }
  } catch (error) {
    console.error('Error fetching all users', error)
    throw new Error('An error occurred while fetching users')
  }
}
